/* eslint-disable import/prefer-default-export */
export const PASSWORD_RESET_STATUS = {
  SUCCESS: '계정의 이메일로 초기화된 비밀번호를 전송하였습니다.',
  NOT_EQUAL: '일치하는 사용자가 없습니다',
  NO_EMAIL: '설정된 이메일 정보가 없습니다.',
  NO_APPLY_ALARM_EMAIL: '이메일 알람 전송을 허용하지 않습니다.',
  // 로그인 오류에 대한 메시지 개선작업 (아이디, 질문과 답변 명시적인 에러 메시지)
  NOT_EQUAL_QUESTION: '비밀번호 찾기 질문 또는 답변이 잘못되었습니다.',
};



// WEBPACK FOOTER //
// ./src/constants/password.js